<template>
    <v-container>     
        <br><br>
        <div class="pa-8">

            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-center"><img src="../../assets/Logo ITP.svg" width="200px" class="pb-5"></div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="d-flex justify-center">
                    <h2>
                        Registro de prestadores de servicios
                    </h2>
                </v-col>
            </v-row>

            <br><br><br>

            
        
            <v-row dense class="d-flex justify-center">
                <v-col cols="12" sm="12" md="3" >
                    <v-text-field v-model="nombre" label="Nombre" :rules="[rules.required]" dense outlined autofocus></v-text-field>
                </v-col>
    
                <v-col cols="12" sm="12" md="3">
                    <v-text-field v-model="apellido_paterno" label="Apellido paterno" :rules="[rules.required]" dense outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="3">
                    <v-text-field v-model="apellido_materno" label="Apellido materno" :rules="[rules.required]" dense outlined></v-text-field>
                </v-col>
            </v-row>
    
            <v-row dense class="d-flex justify-center">
                <v-col sm="12" md="9">
                    <v-text-field v-model="correo" label="Correo" :rules="[rules.required, rules.email]" dense outlined></v-text-field>
                </v-col>
            </v-row>
    
            <v-row dense class="d-flex justify-center">
                <v-col sm="12" md="5">
                    <v-text-field type="password" v-model="contraseña" label="Contraseña" :rules="[rules.required]" dense outlined></v-text-field>
                </v-col>
    
                <v-col sm="12" md="4">
                    <v-text-field type="password" v-model="confirmacion" label="Confirmación" :rules="[rules.required]" dense outlined></v-text-field>
                </v-col>
            </v-row>
    
            <v-row dense class="d-flex justify-center">
                <v-col cols="12" md="9">
                    <v-btn dense color="primary" @click="validacionDatos()" :loading="registrando" dark block>Registrar</v-btn>
                </v-col>
            </v-row>
    
            <v-row dense class="d-flex justify-center">
                <v-col cols="12" md="9">
                    <v-btn dense color="secondary" to="/psplogin" block>Ya tengo una cuenta</v-btn>
                </v-col>
            </v-row>
        </div>

        <v-snackbar v-model="snackbar" :color="snackbarcolor" dark >
            <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
        </v-snackbar>        

    </v-container>
</template>

<script>
export default {
    data() {
        return {
            snackbartexto: "",
            snackbar: false,            
            snackbarcolor: "",

            nombre:"",
            apellido_paterno:"",
            apellido_materno:"",
            correo:"",
            contraseña:"",
            confirmacion:"",

            rules:{
                required: value => !!value || 'Campo requerido',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Correo no valido'
                },               
            },

            registrando: false,

        }
    },

    watch: {           
        nombre(){
            this.nombre = this.nombre.charAt(0).toUpperCase() + this.nombre.slice(1)
        },
        apellido_paterno(){
            this.apellido_paterno = this.apellido_paterno.charAt(0).toUpperCase() + this.apellido_paterno.slice(1)
        },            
        apellido_materno(){
            this.apellido_materno = this.apellido_materno.charAt(0).toUpperCase() + this.apellido_materno.slice(1)
        }            
    },

    methods: {
        validacionDatos(){            
            
            if(this.nombre && this.apellido_paterno && this.apellido_materno && this.correo && this.contraseña && this.confirmacion){//Estan todos los datos
                if(this.confirmacion === this.contraseña){ //Confirmación correcta
                    const usuario = {
                        nombre: this.nombre.toUpperCase(),
                        apellido_paterno: this.apellido_paterno.toUpperCase(),
                        apellido_materno: this.apellido_materno.toUpperCase(),
                        correo: this.correo,
                        contraseña: this.contraseña
                    }

                    this.setRegistro(usuario)
                }
                else{
                    this.snackbartexto="Las contraseñas no coinciden."
                    this.snackbar = true
                    this.snackbarcolor = "error"
                }
            }
            else{
                //Faltó algun dato
                this.snackbartexto = "Todos los campos son requeridos."
                this.snackbar = true
                this.snackbarcolor = "error"
            }

        },        

        setRegistro(usuario){

            if(this.registrando)
                return

            this.registrando = true
            this.axios.post(this.$url+"/psp/registro", {datos: usuario})
                .then((response)=>{
                    let rs = response.data

                    if(rs.error){
                        this.snackbartexto = rs.mensaje
                        this.snackbar = true   
                        this.snackbarcolor = "error"
                    }
                    else{
                        this.snackbartexto = "Usuario creado, redirigiendo..."
                        this.snackbar = true
                        this.snackbarcolor = "success"

                        setTimeout(() => {
                            this.$router.push({name:'PSPLogin'})                            
                        }, 2000);

                    }
                    
                })
                .catch(() =>{
                    this.snackbartexto = "Ocurrió un error en el registro."
                    this.snackbar = true
                    this.snackbarcolor = "error"
                })
                .finally(()=>{
                    this.registrando = false
                })

        }

    },

}
</script>
 
<style>
    h1, h2, h3{
        color: #000000;
    }
   
</style>